export default __webpack_public_path__ + "static/ai-2ffeac9a0b5403365960df512677ca61.gif";